import { useKeenSlider } from "keen-slider/react";
import Image from "next/image";
import { useState, useEffect, CSSProperties } from "react";

import slide1 from "@/img/product/presentation/1.png";
import slide2 from "@/img/product/presentation/2.png";
import slide3 from "@/img/product/presentation/3.png";
import slide4 from "@/img/product/presentation/4.png";
import slide5 from "@/img/product/presentation/5.png";
import slide6 from "@/img/product/presentation/6.png";
import slide7 from "@/img/product/presentation/7.png";
import slide8 from "@/img/product/presentation/8.png";
import slide9 from "@/img/product/presentation/9.png";

const images = [
  slide1,
  slide2,
  slide3,
  slide4,
  slide5,
  slide6,
  slide7,
  slide8,
  slide9,
] as const;

const PresentationGallery = ({ style }: { style?: CSSProperties }) => {
  const [isMounted, setIsMounted] = useState(false);
  const [pause, setPause] = useState(false);

  const [ref, slider] = useKeenSlider<HTMLDivElement>({
    loop: true,
    defaultAnimation: { duration: 1000 },
    slides: { perView: 1 },
    created: () => setIsMounted(true),
    dragStarted: () => {
      setPause(true);
    },
    dragEnded: () => {
      setPause(false);
    },
  });

  useEffect(() => {
    const timer = setInterval(() => {
      if (!pause && slider.current) {
        slider.current.next();
      }
    }, 4000);
    return () => {
      clearInterval(timer);
    };
  }, [pause, slider]);

  return (
    <section
      className="gallery"
      style={{
        borderRadius: 16,
        border: "1px solid rgba(0, 0, 0, 0.125)",
        width: "min(100vw - 48px, 520px)",
        ...style,
      }}
    >
      <div
        ref={ref}
        className="keen-slider"
        style={{ opacity: isMounted ? 1 : 0 }}
      >
        {images.map((img, i) => (
          <figure key={i} className="keen-slider__slide">
            <Image
              src={img}
              alt={`Slide ${i + 1}`}
              placeholder="blur"
              objectFit="cover"
            />
          </figure>
        ))}
      </div>
      <style jsx>{`
        .gallery {
          position: relative;
          max-width: 100%;
          border-radius: 16px;
          z-index: 1;
          overflow: hidden;
          line-height: 0;
        }

        .keen-slider {
          min-width: 0px;
          height: 100%;
          width: 100%;
          display: flex;
          align-items: center;
          border-radius: 16px;
          user-select: none;
          touch-action: pan-y;
          transition: opacity 0.125s ease-in-out;
        }
        .keen-slider__slide {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          flex-shrink: 0;
          max-height: 100%;
          border-radius: 16px;
        }

        .keen-slider__slide > :global(span) {
          flex: 1 1 auto;
        }
      `}</style>
    </section>
  );
};

export default PresentationGallery;
